import { fetchUserApi } from "@/utils/admin"
import { useQuery } from "@tanstack/react-query"


function useUser(isAuth) {
      const { data : userData, isLoading: isUserLoading} = useQuery({
        queryKey: ['current-user'],
        queryFn:fetchUserApi,
        enabled : isAuth,
        cacheTime:60 * 60 * 1000,
        staleTime: 60 * 60 * 1000,
        retry: false
      })

      return {userData, isUserLoading }
}

export default useUser;
